import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CompanySize, PageResponseV2 } from '../models/empresa.model';

@Injectable({
  providedIn: 'root'
})
export class CompanySizeApiService {
  private readonly apiUrl = `${environment.apiUrl}api/company-sizes`;

  constructor(private http: HttpClient) { }

  // GET /api/company-sizes - List all company sizes (paginated)
  getAll(params?: { page?: number; size?: number }): Observable<PageResponseV2<CompanySize>> {
    let queryParams = new HttpParams();
    if (params?.page != null) queryParams = queryParams.set('page', params.page);
    if (params?.size != null) queryParams = queryParams.set('size', params.size);
    return this.http.get<PageResponseV2<CompanySize>>(this.apiUrl, { params: queryParams });
  }

  // GET /api/company-sizes/{id} - Get by ID
  getById(id: number): Observable<CompanySize> {
    return this.http.get<CompanySize>(`${this.apiUrl}/${id}`);
  }

  // POST /api/company-sizes - Create (requires Sales Rep or higher)
  create(companySize: Omit<CompanySize, 'id'>): Observable<CompanySize> {
    return this.http.post<CompanySize>(this.apiUrl, companySize);
  }

  // PUT /api/company-sizes/{id} - Update (requires Sales Rep or higher)
  update(id: number, companySize: Omit<CompanySize, 'id'>): Observable<CompanySize> {
    return this.http.put<CompanySize>(`${this.apiUrl}/${id}`, companySize);
  }

  // DELETE /api/company-sizes/{id} - Delete (requires Admin or higher)
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
